import React, {Component} from 'react';
import root from 'window-or-global';
import PropTypes from 'prop-types';
import Section from './Section';
import Arrow from './Arrow';
import move from 'lodash-move';
import {TweenMax, Power4, Linear} from 'gsap/TweenMax';
import {getBowserState} from '@epic-core/common';
import Swipe from 'react-easy-swipe';

let timeout = null;
let tween = null;
let swipe = {};
let sectionsCache = null;

export default class SliderCarousel extends Component {
    static propTypes = {
        responsive: PropTypes.array,
        driftSpeed: PropTypes.number
    };

    state = {
        secWidth: null,
        ww: 0,
        autoScroll: true,
        slideOpen: null,
        sectionsCache: [],
        slides: 3
    };

    sectionRefs = [];
    curPos = 0;
    isDrift = false;
    scrollSpeed = 0.65;
    autoPlayDelay = 3000;

    UNSAFE_componentWillMount() {
        if (sectionsCache && sectionsCache.length && sectionsCache[0]) {
            this.setState({sectionsCache});
        }
    }

    componentDidMount() {
        const {sections, fromCache} = this.getSections(this.props);
        this.getDimensions(sections, fromCache);
        root.addEventListener('resize', this.resize, false);
        if (this.state.autoScroll && this.state.slideOpen === null) {
            timeout = setTimeout(() => {
                this.autoPlay();
            }, this.autoPlayDelay);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {sections, fromCache} = this.getSections(nextProps);
        this.getDimensions(sections, fromCache);
    }

    componentWillUnmount() {
        root.removeEventListener('resize', this.resize, false);
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        if (tween) {
            tween.kill();
        }
        ({sectionsCache} = this.state);
    }

    getSections(props) {
        const cache = this.state.sectionsCache;
        const fromCache = cache && cache.length && cache[0] && true;
        let sections;
        if (fromCache) {
            sections = cache;
        } else {
            sections = props.sections.sections || [];
        }
        return {sections, fromCache};
    }

    getDimensions = (sections, usingCache) => {
        this.resize(usingCache);
        let newSections;
        if (usingCache) {
            newSections = sections;
        } else {
            newSections = move(sections, sections.length - 1, 0);
        }
        this.setState({sectionsCache: newSections});
    };

    resize = () => {
        this.handleBreakpoints();
        const {slideOpen} = this.state;
        const sections = this.state.sectionsCache;
        const shouldScroll = this.state.autoScroll;
        const {mobile, tablet} = getBowserState();
        //clears timeout if one, kills main tween, and then sets placement for current section to 0
        clearTimeout(timeout);
        if (tween) {
            tween.kill();
        }

        if (shouldScroll && slideOpen === null) {
            timeout = setTimeout(() => {
                this.autoPlay();
            }, this.autoPlayDelay);
        }

        if (slideOpen !== null) {
            for (let i = 0; i < sections.length; i++) {
                if (i === slideOpen) {
                    this.handleSection(slideOpen, true);

                    // Close slide below mobile/tablet threshold
                    if (this.state.ww < 1024 || mobile || tablet) {
                        this.setState({
                            slideOpen: null
                        });
                        this.handleSection(null, true);
                        this.nextSlide();
                    }
                }
            }
        }
    };

    handleBreakpoints = () => {
        const ww = root.innerWidth;
        const ra = this.props.responsive;
        const {slideOpen} = this.state;

        let secWidth = 3;
        let autoScroll = true;
        let slides = 3;
        for (const item of ra) {
            const bp = item.breakpoint;
            const sa = item.slides || 3;
            if (bp && ww < bp) {
                secWidth = Math.round(100 * (ww / sa)) / 100;
                ({autoScroll} = item);
                slides = sa;
            }
        }

        if (!slideOpen) {
            this.setState({
                secWidth,
                ww,
                autoScroll,
                slides
            });
        } else {
            this.setState({
                ww
            });
        }
    };

    autoPlay = () => {
        if (this.state.slideOpen === null && this.state.autoScroll) {
            if (this.track) {
                this.reOrganize(this.state.sectionsCache, 'next');
                this.isDrift = true;
                TweenMax.set(this.track, {x: 0});
                this.slide(true);
            }
        }
    };

    nextSlide = () => {
        if (this.state.slideOpen === null) {
            this.reOrganize(this.state.sectionsCache, this.isDrift ? 'stay' : 'next');
            TweenMax.set(this.track, {x: 0});
            const speed = this.scrollSpeed;
            this.slide(false, speed);
        }
    };

    prevSlide = () => {
        if (this.state.slideOpen === null) {
            this.reOrganize(this.state.sectionsCache, 'prev');
            TweenMax.set(this.track, {x: -(this.state.secWidth * 2)});
            const speed = this.scrollSpeed;
            this.slide(false, speed);
        }
    };

    slide = (autoPlay, speed) => {
        clearTimeout(timeout);
        const travelDistance = -this.state.secWidth;
        //transitions track to next/prev slide
        this.slideMove(this.track, travelDistance, autoPlay, speed);
    };

    slideMove = (el, dist, autoPlay, speed) => {
        if (autoPlay) {
            tween = TweenMax.to(el, this.props.driftSpeed, {
                x: dist,
                ease: Linear.easeNone,
                onComplete: this.driftComplete
            });
        } else {
            this.isDrift = false;
            tween = TweenMax.to(el, speed, {
                x: dist,
                ease: Power4.easeOut,
                onComplete: this.clickComplete
            });
        }
    };

    clickComplete = () => {
        if (this.state.autoScroll && this.state.slideOpen === null) {
            timeout = setTimeout(() => {
                this.autoPlay();
            }, this.autoPlayDelay);
        }
    };

    driftComplete = () => {
        if (this.isDrift && this.state.slideOpen === null) {
            this.autoPlay();
        }
    };

    handleSection = (id, resizing) => {
        clearTimeout(timeout);
        this.setState({slideOpen: id});
        const so = this.state.slideOpen;
        const expandResize = resizing === true && so !== null;
        this.handleBreakpoints();

        if (so !== null || expandResize) {
            if (tween) {
                tween.pause();
            }
            this.expandShrink(id, true, resizing);
        } else if (so === null) {
            this.expandShrink(id, false);
            if (tween && this.isDrift) {
                tween.play();
            } else {
                timeout = setTimeout(() => {
                    this.isDrift = true;
                    TweenMax.set(this.track, {x: -this.state.secWidth});
                    this.autoPlay();
                }, this.autoPlayDelay);
            }
        }
    };

    expandShrink = (item, expand, resizing) => {
        const {sectionRefs} = this;
        for (let i = 0; i < sectionRefs.length; i++) {
            const sectionRef = sectionRefs[i].section; //internal ref from Section.js
            const sectionDim = sectionRef.getBoundingClientRect();
            if (expand) {
                if (i < item) {
                    if (sectionDim.left > -(this.state.secWidth - 1)) {
                        const tranLeft = sectionDim.left + this.state.secWidth;
                        TweenMax.to(sectionRef, 0.7, {
                            x: -tranLeft,
                            ease: Power4.easeOut,
                            delay: 0.3
                        });
                    }
                } else if (i === item) {
                    if (resizing) {
                        TweenMax.set(sectionRef, {width: this.state.ww});
                    } else {
                        TweenMax.to(sectionRef, 0.7, {
                            width: this.state.ww,
                            x: -sectionDim.left,
                            ease: Power4.easeOut,
                            delay: 0.3
                        });
                    }
                } else if (i > item) {
                    if (sectionDim.left < this.state.ww) {
                        const tranRight = this.state.ww - sectionDim.left;
                        TweenMax.to(sectionRef, 0.7, {
                            x: tranRight,
                            ease: Power4.easeOut,
                            delay: 0.3
                        });
                    }
                }
            } else {
                TweenMax.to(sectionRef, 0.5, {
                    x: 0,
                    width: this.state.secWidth,
                    ease: Power4.easeOut
                });
            }
        }
    };

    reOrganize = (sections, direction) => {
        let newSections = sections;

        if (direction === 'next') {
            newSections = move(sections, 0, sections.length - 1);
        } else if (direction === 'prev') {
            newSections = move(sections, sections.length - 1, 0);
        }

        this.setState({sectionsCache: newSections});
    };

    onSwipeStart = (event) => {
        swipe = {
            start: true
        };
    };

    onSwipeMove = (position, event) => {
        const swipeThreshold = 120;
        swipe.x = position.x;
        if (position.x > swipeThreshold) {
            swipe.left = true;
        } else if (position.x < -swipeThreshold) {
            swipe.right = true;
        }
    };

    onSwipeEnd = (event) => {
        if (swipe.left) {
            this.prevSlide();
            swipe.swiped = true;
        } else if (swipe.right) {
            this.nextSlide();
            swipe.swiped = true;
        } else {
            swipe = {};
        }
    };

    isCurrentlySwiping = () => {
        if (swipe && (swipe.start || swipe.swiped) && Math.abs(swipe.x) > 60) {
            swipe = {};
            return true;
        }
        return false;
    };

    render() {
        const sections = this.state.sectionsCache || [];
        const containerWidth = !this.state.slideOpen
            ? this.state.secWidth * sections.length
            : this.state.secWidth * (sections.length - 1) + this.state.ww;
        const containerStyle = {
            width: `${containerWidth + 100}px`,
            WebkitTransform: `matrix(1, 0, 0, 1, ${-this.state.secWidth}, 0)`,
            transform: `matrix(1, 0, 0, 1, ${-this.state.secWidth}, 0)`
        };
        const sects = [];
        const {mobile, tablet} = getBowserState();

        for (let x = 0; x < sections.length; x++) {
            const section = sections[x];
            const sect = (
                <Section
                    id={x}
                    ref={(c) => {
                        this.sectionRefs[x] = c;
                    }}
                    slideOpen={this.state.slideOpen}
                    isSlideOpen={this.state.slideOpen === x}
                    noneOpen={this.state.slideOpen === null}
                    key={`section-${x}`}
                    bkWidth={this.state.ww}
                    funct={this.handleSection}
                    sectionClickCheck={this.isCurrentlySwiping}
                    content={section}
                    width={this.state.secWidth}
                    slideCount={this.state.slides}
                />
            );

            if (mobile || tablet) {
                sects.push(
                    <Swipe
                        key={`swipe-section-${x}`}
                        onSwipeStart={this.onSwipeStart}
                        onSwipeMove={this.onSwipeMove}
                        onSwipeEnd={this.onSwipeEnd}>
                        {sect}
                    </Swipe>
                );
            } else {
                sects.push(sect);
            }
        }
        return (
            <div
                id="sliderWrapper"
                ref={(c) => {
                    this.slideContainer = c;
                }}
                className="text-center">
                <Arrow
                    key="prevArrow"
                    prev
                    hide={this.state.slideOpen !== null}
                    funct={this.prevSlide}
                />
                <div
                    ref={(c) => {
                        this.track = c;
                    }}
                    className="slideTrack"
                    style={containerStyle}>
                    {sects}
                </div>
                <Arrow
                    key="nextArrow"
                    hide={this.state.slideOpen !== null}
                    funct={this.nextSlide}
                />
            </div>
        );
    }
}
